import React from 'react';
import { LandingPageDiv } from './landingPageStyle';
import Home from '../../components/home/Home';
import { useContext } from 'react';
import AgbaContext from '../../context/agba/agbaContext';

const LandingPage = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar } = agbaContext;

  return (
    <LandingPageDiv sideBar={sideBar}>
      <div className='page'>
        <p className='tags top-tags'>&lt;body&gt;</p>
        <Home />
      </div>
    </LandingPageDiv>
  );
};

export default LandingPage;
